import React from 'react'
import './styles.scss'

// If this proves nice, we might move it out of here and reuse it
function Laptop({ url, title = 'Code demo' }) {
  return (
    <div className="laptop-iframe-styles">
      <iframe title={title} src={url} frameBorder="0" />
    </div>
  )
}

export default Laptop
